<template>
 <div>Callback</div>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";

const AdminRepo = RepositoryFactory.get('admin')
export default {
  name: "RedditAuthCb",
  mounted() {
    const parsedParams = {};
    this.$route.hash.split('&')
        .map(part => part.replace(/#/, ''))
        .forEach(param => {
          const parts = param.split('=');
          parsedParams[parts[0]] = parts[1];
        });

    let state = null;
    if ('state' in parsedParams) {
      state = JSON.parse(decodeURIComponent(parsedParams.state));
      if (state.loginId !== localStorage.getItem('loginDataId')) {
        this.$router.push('/')
        return;
      }
      localStorage.removeItem('loginDataId')
    }

    const userData = {
      access_token: parsedParams.access_token,
      token_type: parsedParams.token_type,
      expires_in: parsedParams.expires_in,
      scope: parsedParams.scope,
      username: '',
      avatar: ''
    }

    const config = {
      headers: { Authorization: `Bearer ${parsedParams.access_token}` }
    };
    this.$http.get('https://oauth.reddit.com/api/v1/me/', config)
    .then(res => {
      userData.username = res.data.name;
      userData.avatar = res.data.icon_img.split('?')[0];
      this.$store.dispatch('login', {user: userData, vm: this})
      localStorage.setItem('avatar', userData.avatar)

      AdminRepo.getUser({params: {token: this.$store.getters.token}})
          .then(res => {
            if (res.status !== 'error') {
              this.$store.dispatch('set_admin_data', res.data)
            }
            if (state !== null && 'origin' in state) {
              this.$router.push({name: state.origin})
            } else {
              this.$router.push('/')
            }
          })



    })
    .catch(function (error) {
      console.log(error)
    })





    }
}
</script>

<style scoped>

</style>
